// Редът „Общо" на решетката „Прехвърляне": Нето и Бруто под колоните си,
// лепнат за дъното на картата (`WorksheetTotalsRow`).
import { useTranslation } from "react-i18next";
import {
  TotalsBlankCell,
  TotalsLabelCell,
  TotalsValueCell,
  WorksheetTotalsRow,
} from "../../components/worksheet/WorksheetTotalsRow";
import { formatMoney } from "../../components/numbers";
import { LINE_GRID_CLASS, LINE_GRID_COLUMN_COUNT } from "./transferWorksheetShared";

type Props = {
  count: number;
  totalNet: number;
  totalGross: number;
};

export const TransferTotalsRow = ({ count, totalNet, totalGross }: Props) => {
  const { t } = useTranslation();
  return (
    <WorksheetTotalsRow gridClass={LINE_GRID_CLASS} columnCount={LINE_GRID_COLUMN_COUNT}>
      {/* # · Продукт · Ед. · Наличност · Количество · Партида · Остава · Става · Ед. цена */}
      <TotalsLabelCell span={9} title={t("inventoryPage.total")} detail={t("inventoryPage.homeDraftLines", { count })} />
      <TotalsValueCell value={formatMoney(totalNet)} />
      <TotalsValueCell value={formatMoney(totalGross)} strong />
      <TotalsBlankCell span={1} last />
    </WorksheetTotalsRow>
  );
};

export default TransferTotalsRow;
